import React, { useEffect, useState } from "react";
import Footer from "../../components/Footer/Footer";
import PreLoginHeader from "../../components/PreLoginHeader/PreLoginHeader";
import Header from "../../components/Header/Header";
import { useSearchParams } from "react-router-dom";
import { fetchData } from "../../services/apiService";

function ConfirmBooking() {
  const token = localStorage.getItem("token");
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [bookingDetail, setBookingDetail] = useState(null);

  const getbookingDetail = async (id) => {
    try {
      const data = await fetchData(`api/booking/get-booking-detail/${id}`);
      setBookingDetail(data);
    } catch (error) {
      console.error("ERROR -> ", error);
    }
  };

  useEffect(() => {
    getbookingDetail(id);
  }, []);
  return (
    <div className="confirmation-app">
      {token ? <Header /> : <PreLoginHeader />}

      <div className="confirmation-hero">
        <div className="hero-content">
          <h1>Your Appointment is Confirmed!</h1>
          <p>We're looking forward to seeing you</p>
        </div>
      </div>

      <div className="confirmation-container">
        <div className="confirmation-card">
          <div className="confetti"></div>
          <div className="checkmark">✓</div>

          <h2>Thank You {bookingDetail?.user?.firstName} for Booking</h2>
          <p className="appointment-details">
            Your consultation is scheduled for
            <br />
            <strong>
              {new Date(bookingDetail?.meetingStartSlot).toLocaleDateString(
                "en-US",
                {
                  weekday: "long",
                  month: "long",
                  day: "numeric",
                }
              )}{" "}
              at{" "}
              {new Date(bookingDetail?.meetingStartSlot).toLocaleTimeString(
                [],
                {
                  hour: "2-digit",
                  minute: "2-digit",
                }
              )}
            </strong>
          </p>

          <div className="confirmation-actions">
            <a href="/app/home" className="action-btn primary">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <path d="M9 22V12h6v10" stroke="currentColor" strokeWidth="2" />
              </svg>
              Go To Home
            </a>

            <a
              href="/app/appointment-scheduling"
              className="action-btn tertiary"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M3 10h18M7 15h1m4 0h1m4 0h1M3 19h18a2 2 0 002-2V7a2 2 0 00-2-2H3a2 2 0 00-2 2v10a2 2 0 002 2z"
                  stroke="currentColor"
                  strokeWidth="2"
                />
              </svg>
              Schedule Another Meeting
            </a>
          </div>

          <div className="confirmation-info">
            <div className="info-item">
              <div className="info-icon">📧</div>
              <div>
                <h4>Confirmation Sent</h4>
                <p>We've emailed details to {bookingDetail?.attendeeEmail}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="next-steps">
          <h3>What to Do Next</h3>
          <ul>
            <li>Check your email for Invitation</li>
            <li>Accept the Invitation</li>
            <li>Add the appointment to your calendar</li>
            <li>Prepare any questions for your provider</li>
          </ul>

          <div className="testimonial">
            <div className="author">- Important</div>
            <p>
              "You will receive an email shortly with Invitation and Meet Link.
              Please Accept the Invitation so that your booking got confirmed"
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default ConfirmBooking;
